import { render, staticRenderFns } from "./Bendahara.vue?vue&type=template&id=6ed6e92e&"
import script from "./Bendahara.vue?vue&type=script&lang=js&"
export * from "./Bendahara.vue?vue&type=script&lang=js&"
import style0 from "./Bendahara.vue?vue&type=style&index=0&id=6ed6e92e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports